// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalShare--loUHy {
  display: 'block';
}

.checkbox--WoLss {
  vertical-align: middle;
}

[dir=ltr] .checkbox--WoLss {
  margin-right: 5px;
}

[dir=rtl] .checkbox--WoLss {
  margin-left: 5px;
}

.shareModalBody--lafnx {
  color: white;
  transition: all 0.2s ease-in;
}

[dir] .shareModalBody--lafnx {
  padding: 20px;
  background-color: #0e3b83;
}

.closeButton--XqMA3 {
  color: #f59201;
}

.tabsWrapper--gGHwN {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

[dir] .tabsWrapper--gGHwN {
  margin-bottom: 30px;
}

.tabButton--OuoDj {
  height: 30px;
  font-weight: bold;
  font-size: 15px;
}

[dir] .tabButton--OuoDj {
  padding: 5px 10px;
  margin-bottom: 0;
  cursor: pointer;
  background: #6e89b5;
}

[dir=ltr] .tabButton--OuoDj {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-right: 5px;
}

[dir=rtl] .tabButton--OuoDj {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  margin-left: 5px;
}

.tabButton--OuoDj:hover {
  filter: brightness(115%);
}

[dir] .tabButtonActive--pL7lm {
  background: #e6512d;
}

[dir=ltr] .buttonIcon--ffRz_ {
  margin-right: 5px;
}

[dir=rtl] .buttonIcon--ffRz_ {
  margin-left: 5px;
}

.textArea--o9scz {
  color: white;
  width: 95%;
}

[dir] .textArea--o9scz {
  background: transparent;
  border: 1px solid #e6512d;
  border-radius: 0;
  padding: 5px 10px;
}

.textArea--o9scz:focus-visible {
  outline: none;
}

.tabButtonInput--OtnBw:checked + .tabButton--OuoDj {
  color: white;
  height: 32px;
}

[dir] .tabButtonInput--OtnBw:checked + .tabButton--OuoDj {
  background: #e6512d;
}

.panel--NdVDQ {
  width: 100%;
}

#panel1--UOhdP,
#panel2--eUt7f {
  display: none;
  order: 99;
}

.tabButtonInput--OtnBw:checked + .tabButton--OuoDj + #panel1--UOhdP,
.tabButtonInput--OtnBw:checked + .tabButton--OuoDj + #panel2--eUt7f {
  display: block;
}

.socialButtonsWrapper--J3jXj {
  display: block;
  width: 100%;
}

.socialButtonsTitle--zbXW7 {
  font-size: 17px;
  font-weight: 800;
  display: inline-block;
}

.socialButton--EyWU3 {
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
}

[dir] .socialButton--EyWU3 {
  background: #e6512d;
  border-radius: 50%;
  cursor: pointer;
  text-align: center;
}

[dir=ltr] .socialButton--EyWU3 {
  margin-left: 5px;
}

[dir=rtl] .socialButton--EyWU3 {
  margin-right: 5px;
}

[dir] .devider--BXBzQ {
  border-top: 1px solid white;
  margin-top: 10px;
}

.shareButtonsWrapper--SWOBL {
  display: block;
  width: 100%;
}

.emailTitle--uKqqh {
  font-weight: 800;
}

.shareButton--IfjiG {
  color: black;
  display: inline-block;
  font-size: 14px;
}

[dir] .shareButton--IfjiG {
  background: white;
  border-radius: 5px;
  padding: 4px 8px;
  cursor: pointer;
}

[dir=ltr] .shareButton--IfjiG {
  margin: 5px 5px 5px 0;
}

[dir=rtl] .shareButton--IfjiG {
  margin: 5px 0 5px 5px;
}

.shareButton--IfjiG:hover {
  filter: brightness(95%);
}

.confirmButton--SFMRX {
  color: white;
}

[dir] .confirmButton--SFMRX {
  background: #e6512d;
}

[dir] .saveViewTextArea--xUhez {
  margin-top: 10px;
}

.copyToClipboardButton--IN3jY {
  color: white;
  vertical-align: top;
  height: 36px;
  align-items: center;
  justify-content: center;
  display: inline-flex;
}

[dir=ltr] .copyToClipboardButton--IN3jY {
  margin-left: 5px;
}

[dir=rtl] .copyToClipboardButton--IN3jY {
  margin-right: 5px;
}

.copyToClipboardButton--IN3jY:hover {
  color: #e6512d;
}

[dir] .copyToClipboardButton--IN3jY:hover {
  cursor: pointer;
}

.copyToClipboardButton--IN3jY:focus {
  color: white;
}

[dir] .copyToClipboardButton--IN3jY:focus {
  cursor: pointer;
}

.notificationWrapper--r8gqm {
  height: 30px;
}

[dir] .notificationWrapper--r8gqm {
  margin-top: 15px;
}

.embedInput--SReBo {
  height: 186px;
}

.advancedWrapper--jL95C {
  width: 95%;
}

[dir] .advancedWrapper--jL95C {
  background: #e6512d;
}

[dir=ltr] .advancedWrapper--jL95C {
  text-align: right;
}

[dir=rtl] .advancedWrapper--jL95C {
  text-align: left;
}

.advancedHeader--ETfMr {
  font-weight: 700;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

[dir] .advancedHeader--ETfMr {
  cursor: pointer;
  padding: 6px 10px;
}

.advancedBody--S9wET {
  width: 95%;
  color: black;
}

[dir] .advancedBody--S9wET {
  background: #f5f5f5;
  padding: 15px;
}

[dir=ltr] .advancedBody--S9wET {
  text-align: left;
}

[dir=rtl] .advancedBody--S9wET {
  text-align: right;
}

[dir] .advancedInput--Fwi_0 {
  border: 1px solid grey;
  border-radius: 0;
}

[dir=ltr] .advancedInput--Fwi_0 {
  margin-right: 5px;
}

[dir=rtl] .advancedInput--Fwi_0 {
  margin-left: 5px;
}

.advancedInput--Fwi_0:focus-visible {
  outline: none;
}

.gridContainer--j1udw {
  display: grid;
  grid-template-columns: 15% auto;
}

[dir] .gridContainer--j1udw {
  margin-top: 10px;
}
.textArea--o9scz::-webkit-scrollbar {
  width: 6px;
}
[dir] .textArea--o9scz::-webkit-scrollbar {
  border-radius: 3px;
}

/* Track */
[dir] .textArea--o9scz::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
[dir] .textArea--o9scz::-webkit-scrollbar-thumb {
  background: #e6512d;
  border-radius: 3px;
}

/* Handle on hover */
[dir] .textArea--o9scz::-webkit-scrollbar-thumb:hover {
  background: #e6512d;
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/Modals/Share/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EAEE,sBAAsB;AACxB;;AAHA;EACE,iBAAiB;AAEnB;;AAHA;EACE,gBAAiB;AAEnB;;AAEA;EAGE,YAAY;EACZ,4BAA4B;AAC9B;;AALA;EACE,aAAa;EACb,yBAAyB;AAG3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AAEjB;;AALA;EAIE,mBAAmB;AACrB;;AAEA;EAME,YAAY;EAEZ,iBAAiB;EACjB,eAAe;AAEjB;;AAXA;EAGE,iBAAiB;EAEjB,gBAAgB;EAEhB,eAAe;EAGf,mBAAmB;AACrB;;AAXA;EACE,2BAA2B;EAC3B,4BAA4B;EAE5B,iBAAiB;AAOnB;;AAXA;EACE,4BAA2B;EAC3B,2BAA4B;EAE5B,gBAAiB;AAOnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,gBAAiB;AACnB;;AAEA;EAEE,YAAY;EAIZ,UAAU;AACZ;;AAPA;EACE,uBAAuB;EAEvB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AAEnB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,YAAY;EACZ,YAAY;AACd;;AAJA;EACE,mBAAmB;AAGrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EAGE,WAAW;EACX,YAAY;EAEZ,qBAAqB;EAErB,iBAAiB;AAEnB;;AAVA;EACE,mBAAmB;EACnB,kBAAkB;EAGlB,eAAe;EAEf,kBAAkB;AAGpB;;AAVA;EASE,gBAAgB;AAClB;;AAVA;EASE,iBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,YAAY;EAIZ,qBAAqB;EACrB,eAAe;AAEjB;;AATA;EACE,iBAAiB;EAEjB,kBAAkB;EAClB,gBAAgB;EAIhB,eAAe;AACjB;;AATA;EAKE,qBAAqB;AAIvB;;AATA;EAKE,qBAAqB;AAIvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AAEtB;;AARA;EAOE,gBAAgB;AAClB;;AARA;EAOE,iBAAgB;AAClB;;AAEA;EACE,cAAc;AAEhB;;AAHA;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AAEd;;AAHA;EAEE,eAAe;AACjB;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,gBAAgB;AAElB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,UAAU;AAEZ;;AAJA;EACE,mBAAmB;AAGrB;;AAJA;EAGE,iBAAiB;AACnB;;AAJA;EAGE,gBAAiB;AACnB;;AAEA;EAGE,gBAAgB;EAChB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AALA;EACE,eAAe;EACf,iBAAiB;AAGnB;;AAEA;EACE,UAAU;EAEV,YAAY;AAGd;;AANA;EAEE,mBAAmB;EAGnB,aAAa;AACf;;AANA;EAIE,gBAAgB;AAElB;;AANA;EAIE,iBAAgB;AAElB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAElB;;AAJA;EAGE,iBAAiB;AACnB;;AAJA;EAGE,gBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;EACb,+BAA+B;AACjC;;AAJA;EACE,gBAAgB;AAGlB;AACA;EACE,UAAU;AAEZ;AAHA;EAEE,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".modalShare {\n  display: 'block';\n}\n\n.checkbox {\n  margin-right: 5px;\n  vertical-align: middle;\n}\n\n.shareModalBody {\n  padding: 20px;\n  background-color: #0e3b83;\n  color: white;\n  transition: all 0.2s ease-in;\n}\n\n.closeButton {\n  color: #f59201;\n}\n\n.tabsWrapper {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 30px;\n}\n\n.tabButton {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  padding: 5px 10px;\n  margin-right: 5px;\n  margin-bottom: 0;\n  height: 30px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 15px;\n  background: #6e89b5;\n}\n\n.tabButton:hover {\n  filter: brightness(115%);\n}\n\n.tabButtonActive {\n  background: #e6512d;\n}\n\n.buttonIcon {\n  margin-right: 5px;\n}\n\n.textArea {\n  background: transparent;\n  color: white;\n  border: 1px solid #e6512d;\n  border-radius: 0;\n  padding: 5px 10px;\n  width: 95%;\n}\n\n.textArea:focus-visible {\n  outline: none;\n}\n\n.tabButtonInput:checked + .tabButton {\n  background: #e6512d;\n  color: white;\n  height: 32px;\n}\n\n.panel {\n  width: 100%;\n}\n\n#panel1,\n#panel2 {\n  display: none;\n  order: 99;\n}\n\n.tabButtonInput:checked + .tabButton + #panel1,\n.tabButtonInput:checked + .tabButton + #panel2 {\n  display: block;\n}\n\n.socialButtonsWrapper {\n  display: block;\n  width: 100%;\n}\n\n.socialButtonsTitle {\n  font-size: 17px;\n  font-weight: 800;\n  display: inline-block;\n}\n\n.socialButton {\n  background: #e6512d;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  display: inline-block;\n  text-align: center;\n  line-height: 30px;\n  margin-left: 5px;\n}\n\n.devider {\n  border-top: 1px solid white;\n  margin-top: 10px;\n}\n\n.shareButtonsWrapper {\n  display: block;\n  width: 100%;\n}\n\n.emailTitle {\n  font-weight: 800;\n}\n\n.shareButton {\n  background: white;\n  color: black;\n  border-radius: 5px;\n  padding: 4px 8px;\n  margin: 5px 5px 5px 0;\n  display: inline-block;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.shareButton:hover {\n  filter: brightness(95%);\n}\n\n.confirmButton {\n  background: #e6512d;\n  color: white;\n}\n\n.saveViewTextArea {\n  margin-top: 10px;\n}\n\n.copyToClipboardButton {\n  color: white;\n  vertical-align: top;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  display: inline-flex;\n  margin-left: 5px;\n}\n\n.copyToClipboardButton:hover {\n  color: #e6512d;\n  cursor: pointer;\n}\n\n.copyToClipboardButton:focus {\n  color: white;\n  cursor: pointer;\n}\n\n.notificationWrapper {\n  margin-top: 15px;\n  height: 30px;\n}\n\n.embedInput {\n  height: 186px;\n}\n\n.advancedWrapper {\n  background: #e6512d;\n  width: 95%;\n  text-align: right;\n}\n\n.advancedHeader {\n  cursor: pointer;\n  padding: 6px 10px;\n  font-weight: 700;\n  user-select: none;\n}\n\n.advancedBody {\n  width: 95%;\n  background: #f5f5f5;\n  color: black;\n  text-align: left;\n  padding: 15px;\n}\n\n.advancedInput {\n  border: 1px solid grey;\n  border-radius: 0;\n  margin-right: 5px;\n}\n\n.advancedInput:focus-visible {\n  outline: none;\n}\n\n.gridContainer {\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: 15% auto;\n}\n.textArea::-webkit-scrollbar {\n  width: 6px;\n  border-radius: 3px;\n}\n\n/* Track */\n.textArea::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n.textArea::-webkit-scrollbar-thumb {\n  background: #e6512d;\n  border-radius: 3px;\n}\n\n/* Handle on hover */\n.textArea::-webkit-scrollbar-thumb:hover {\n  background: #e6512d;\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalShare": `modalShare--loUHy`,
	"checkbox": `checkbox--WoLss`,
	"shareModalBody": `shareModalBody--lafnx`,
	"closeButton": `closeButton--XqMA3`,
	"tabsWrapper": `tabsWrapper--gGHwN`,
	"tabButton": `tabButton--OuoDj`,
	"tabButtonActive": `tabButtonActive--pL7lm`,
	"buttonIcon": `buttonIcon--ffRz_`,
	"textArea": `textArea--o9scz`,
	"tabButtonInput": `tabButtonInput--OtnBw`,
	"panel": `panel--NdVDQ`,
	"panel1": `panel1--UOhdP`,
	"panel2": `panel2--eUt7f`,
	"socialButtonsWrapper": `socialButtonsWrapper--J3jXj`,
	"socialButtonsTitle": `socialButtonsTitle--zbXW7`,
	"socialButton": `socialButton--EyWU3`,
	"devider": `devider--BXBzQ`,
	"shareButtonsWrapper": `shareButtonsWrapper--SWOBL`,
	"emailTitle": `emailTitle--uKqqh`,
	"shareButton": `shareButton--IfjiG`,
	"confirmButton": `confirmButton--SFMRX`,
	"saveViewTextArea": `saveViewTextArea--xUhez`,
	"copyToClipboardButton": `copyToClipboardButton--IN3jY`,
	"notificationWrapper": `notificationWrapper--r8gqm`,
	"embedInput": `embedInput--SReBo`,
	"advancedWrapper": `advancedWrapper--jL95C`,
	"advancedHeader": `advancedHeader--ETfMr`,
	"advancedBody": `advancedBody--S9wET`,
	"advancedInput": `advancedInput--Fwi_0`,
	"gridContainer": `gridContainer--j1udw`
};
export default ___CSS_LOADER_EXPORT___;
